import * as Sentry from '@sentry/react';
export const initSentry = (history)=>{
    if (!window.sentryEnvironment) return;
    Sentry.init({
        dsn: 'https://ff94ed3a7d9149d3b85db4470ae506e1@o326813.ingest.sentry.io/1835583',
        environment: window.sentryEnvironment,
        integrations: [
            Sentry.reactRouterV5BrowserTracingIntegration({
                history
            }),
            // See: https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: [
                    'anchor-frontend-sentry-key'
                ],
                behaviour: 'apply-tag-if-contains-third-party-frames'
            })
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            /(my|demo).anchor.sh/
        ],
        release: GIT_SHA1,
        denyUrls: [
            /^chrome-extension:\/\//i,
            /^safari-extension:\/\//i,
            /clarity\.js/i,
            /adsscriptloaderstatic/i,
            /\/\/hidden\//i,
            /\/appcues/i,
            /googletagmanager\.com/i,
            /this\.nexusWebSocket/i,
            /\/collectedforms\.js/i,
            /\/li.lms-analytics/i,
            /hotjar/i,
            /\/frame-/i,
            /google-analytics\.com\/analytics\.js/i,
            /translate\.googleapis\.com/i,
            /translate\.google\.com/i,
            /msDiscoverChatAvailable/i,
            /\/Applications\//,
            /\/persona\.js/,
            /js\.stripe\.com/,
            /@stripe\/stripe-js/,
            /intercom/,
            /maps\.googleapis\.com/,
            /\/parchment\//,
            /\/quill\.js/,
            /hs-analytics/,
            /material-ui\.js$/,
            /zapier\.com/
        ],
        ignoreErrors: [
            "Failed to execute 'sendBeacon' on 'Navigator'",
            /Network Error/i,
            /NetworkError/i,
            /__gCrWeb/,
            /\[Parchment\]/i,
            /^AxiosError:/,
            'ResizeObserver loop limit exceeded',
            "Failed to execute 'removeChild' on 'Node'",
            "Can't find variable: gmo",
            "Cannot read properties of undefined (reading 'domInteractive')",
            "Can't find variable: lastScrollEventTimestamp"
        ],
        beforeBreadcrumb (breadcrumb, hint) {
            if (breadcrumb.category === 'ui.click' || breadcrumb.category === 'ui.input') {
                var _hint_event_target_dataset, _hint_event_target, _hint_event;
                const testId = hint === null || hint === void 0 ? void 0 : (_hint_event = hint.event) === null || _hint_event === void 0 ? void 0 : (_hint_event_target = _hint_event.target) === null || _hint_event_target === void 0 ? void 0 : (_hint_event_target_dataset = _hint_event_target.dataset) === null || _hint_event_target_dataset === void 0 ? void 0 : _hint_event_target_dataset.testId;
                if (testId) {
                    breadcrumb.message = "data-testid=".concat(testId);
                }
            }
            return breadcrumb;
        }
    });
    if (window._sessionId) {
        Sentry.setTag('sessionId', window._sessionId);
    }
};
